export default function (Component) {
Component.options.__tip = "<p>Use the <code>body</code>-slot to display custom content in a popover.</p>\n"
}